import { Text } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

export const CustomText = ({ size, ...props }) => {
  const isDesktop = useIsDesktop();
  const responsiveSize = size ?? (isDesktop ? "md" : "sm");
  return <Text size={responsiveSize} {...props} />;
};
